// extracted by css-extract-rspack-plugin
export default {"settings":"a_XKL04w3bECgubu","layout":"L0pWih6czMloZXw0"};